<template>
  <div>
    <div class="p-6 py-4">
      <label class="text-base font-semibold text-theme-37">อาชีพ</label>
      <hr class="mt-3 border-theme-39">
    </div>
    <div class="p-6 flex flex-wrap">
      <CustomAccordion
        class="w-full md:w-5/12 lg:w-3/12 m-3"
        headerText="อาชีพหลัก"
        :have="haveOccupComputed"
        :detail="occupDetailComputed"
        accordion-id="primaryOccup"
      />
      <CustomAccordion
        class="w-full md:w-5/12 lg:w-3/12 m-3"
        headerText="อาชีพรอง"
        :have="haveOccupSecComputed"
        :detail="secondOccupComputed"
        accordion-id="secondaryOccup"
      />
      <CustomAccordion
        class="w-full md:w-5/12 lg:w-3/12 m-3"
        headerText="รายได้กรณีไม่ประกอบอาชีพ"
        :have="haveNoOccupComputed"
        :detail="noOccupComputed"
        accordion-id="noOccup"
      />
    </div>
    <div class="p-6 py-4">
      <label class="text-base font-semibold text-theme-37">รายได้/จ่าย</label>
      <hr class="mt-3 border-theme-39">
    </div>
    <div class="p-6 flex flex-wrap">
      <CustomAccordion
        class="w-full md:w-5/12 lg:w-3/12 m-3"
        headerText="เงินออม"
        :have="haveSaving"
        :detail="savingDetailComputed"
        accordion-id="saving"
      />
      <CustomAccordion
        class="w-full md:w-5/12 lg:w-3/12 m-3"
        headerText="รายจ่าย"
        :have="haveExpComputed"
        :detail="expDetailComputed"
        accordion-id="expenditure"
      />
      <CustomAccordion
        class="w-full md:w-5/12 lg:w-3/12 m-3"
        headerText="หนี้สิน"
        :have="haveDeptComputed"
        :detail="debtDetailComputed"
        accordion-id="debt"
      />
    </div>
    <div class="p-6 py-4">
      <label class="text-base font-semibold text-theme-37">ทรัพย์สิน</label>
      <hr class="mt-3 border-theme-39">
    </div>
    <div class="p-6 flex flex-wrap">
       <CustomAccordion
        class="w-full md:w-5/12 lg:w-3/12 m-3"
        :headerText="asset.name"
        :detail="asset.list"
        v-for="(asset, key) in assetListComputed"
        :key="key"
        :have="asset.list?.length>0"
        :accordion-id="`asset-${key}`"
      />
    </div>
  </div>
</template>
<script setup>
import CustomAccordion from "@/components/base/custom-accordion/index.vue";
import { computed } from "vue";

const props = defineProps({
  information: Object,
});

const haveOccupComputed = computed(() => {
  return props.information.occup_status === 1 ? true : false;
});
const occupDetailComputed = computed(() => {
  const result = [];
  if (props.information.occup_status){
    result.push({
      title: props.information.primary_occup.desc == "อื่นๆ" ? props.information.primary_occup.desc+' ('+props.information.primary_occup.occu_name+')' : props.information.primary_occup.desc,
      value: new Intl.NumberFormat().format(props.information.pri_occup_income),
      unit: "บาท",
    });
  }

  return result;
});
const haveOccupSecComputed = computed(()=>{
  return props.information.occup_status === 1 && props.information.secondary_occup?.length > 0 ? true : false;
})
const haveNoOccupComputed = computed(()=>{
  return props.information.occup_status === 0 && props.information.get_subsidy ? true : false;
})
const noOccupComputed = computed(()=>{
  const result = []
  if(props.information.occup_status === 0){
    result.push({
      title: `${props.information.get_subsidy === 1 ? 'ผู้อื่นสนับสนุน' : 'สวัสดิการ'}`,
      value: props.information.get_subsidy === 1 ? new Intl.NumberFormat().format(props.information.subsidy_amount) : "",
      unit: props.information.get_subsidy === 1 ? "บาท" : "",
    });
  }
  return result
})
const secondOccupComputed = computed(()=>{
  const result = [];
  if(props.information.secondary_occup?.length > 0){
    let list_career = ""
    props.information.secondary_occup.forEach((element,idx) => {
      list_career +=`${element.desc == "อื่นๆ"? element.desc +' ('+element.occu_name+')' : element.desc}${idx != props.information.secondary_occup.length-1 ? ', ':''}`
    });
    result.push({
      title: list_career,
      value: new Intl.NumberFormat().format(props.information.sec_occup_income),
      unit: "บาท",
    });
  }
  return result;
})


const haveDeptComputed = computed(() => {
  return props.information.have_debt === 1 ? true : false;
});
const debtDetailComputed = computed(() => {
  let result = [];
  if (props.information.debt?.length>0)
    for (let index = 0; index < props.information.debt.length; index++) {
      const element = props.information.debt[index];
      const temp = {
        title: element.type,
        value: new Intl.NumberFormat().format(element.amount),
        unit: "บาท",
      };
      result.push(temp);
    }
  return result;
});

const haveSaving = computed(() => {
  return props.information.SUM_SAVING ? true : false;
});
const savingDetailComputed = computed(() => {
  let result = [];
  if (props.information.saving?.length>0)
    for (let index = 0; index < props.information.saving.length; index++) {
      const element = props.information.saving[index];
      const temp = {
        title: element.desc == "SV7"? element.desc +' ('+element.saving_name+')' : element.desc ,
        value: element.amount ? new Intl.NumberFormat().format(element.amount) : '-',
        unit: "บาท",
      };
      result.push(temp);
    }
  return result;
});
const haveExpComputed = computed(() => {
  return props.information.SUM_EXPENDITURE ? true : false;
});
const expDetailComputed = computed(() => {
  let result = [];
  if (props.information.expenditure?.length>0){
    for (let index = 0; index < props.information.expenditure.length; index++) {
      const element = props.information.expenditure[index];
      if(element.hasOwnProperty("expenditure_other")){
        const temp = {
          title: element.desc,
          value: "",
          unit: "",
        };
        result.push(temp)
        for(let j = 0; j < element.expenditure_other.length; j++){
          const exp_other = element.expenditure_other[j]
          const temp = {
            title: exp_other.expenditure_name,
            value: new Intl.NumberFormat().format(exp_other.amount),
            unit: "บาท",
          };
          result.push(temp)
        }
      }else{
        const temp = {
          title: element.desc,
          value: new Intl.NumberFormat().format(element.amount),
          unit: "บาท",
        };
        result.push(temp);
      }
    }
  }
  return result;
});
const assetListComputed = computed(()=>{
  let result = []
  let Obj_key = ["land","gold","livestock", "building","machinery"]
  Obj_key.forEach(element => {
    let naming, unit_text
    let asset = []
    if(element == "land"){
        naming = "ที่ดิน"
        unit_text = "ไร่"
    }else if(element == "gold"){
        naming = "ทอง"
        unit_text = "บาท"
    }else if(element == "livestock"){
        naming = "สัตว์เศรษฐกิจ"
        unit_text = "ตัว"
    }else if(element == "building"){
        naming = "สิ่งปลูกสร้าง"
        unit_text = "หลัง"
    }else if(element == "machinery"){
        naming = "เครื่องจักร"
        unit_text = "เครื่อง"
    }
      if((props.information.asset ?? false) && (props.information.asset?.[element])){
        if(props.information.asset[element].length > 0){
          for (let index = 0; index < props.information.asset[element].length; index++) {
            const item = props.information.asset[element][index];
            const temp = {
              title: item.type,
              value: new Intl.NumberFormat().format(item.amount),
              unit: unit_text,
            };
            asset.push(temp);
          }
        }
        else{
          asset.push({
            title: "จำนวน",
            value: new Intl.NumberFormat().format(props.information.asset[element]),
            unit: unit_text,
          })
        }
        result.push({name: naming, list: asset})
      }
      else{
        result.push({
          name: naming,
          list: asset
        })
      }
  });
  return result
})
</script>
